import React from "react";
import { HashLink as Link } from "react-router-hash-link";

export default function AgencyCenter({ isOpen, onClose }) {
  return (
    <div className={`settings-sidebar ${isOpen ? "" : "hidden"}`}>
      {/* Header */}
      <div className="settings-header">
        <h2>Menu & paramétrage</h2>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      </div>

      {/* Primary Links */}
      <nav className="settings-nav">
        <Link
          to="/mission-list-agency"
          className="settings-item"
          onClick={onClose}
        >
          <i className="fa-solid fa-briefcase" />
          <span>Mes offres</span>
        </Link>
        <Link
          to="/agency/listAgency"
          className="settings-item"
          onClick={onClose}
        >
          <i className="fa-solid fa-house" />
          <span>Annuaire des agences</span>
        </Link>
        <Link
          to="/candidate-tracking"
          className="settings-item"
          onClick={onClose}
        >
          <i className="fa-solid fa-list-ul" />
          <span>Suivi des candidatures</span>
        </Link>
      </nav>

      {/* Divider */}
      <div className="divider" />

      {/* Secondary Links */}
      <nav className="settings-nav secondary">
        <Link
          to="/synthese-financiere"
          className="settings-item"
          onClick={onClose}
        >
          <i className="fa-solid fa-sync-alt" />
          <span>Synthèse financière</span>
        </Link>
        <Link
          to="/mission-list-agency"
          className="settings-item"
          onClick={onClose}
        >
          <i className="fa-solid fa-flag" />
          <span>Historique des missions</span>
        </Link>
        <Link to="/edit-profile-company" className="settings-item" onClick={onClose}>
          <i className="fa-regular fa-user" />
          <span>Modifier le profil</span>
        </Link>
        <Link
          to="/interim-research"
          className="settings-item"
          onClick={onClose}
        >
          <i className="fa-solid fa-search" />
          <span>Rechercher des intérimaires</span>
        </Link>
        <div className="divider" />
      </nav>

      {/* Footer */}
      <div className="settings-footer">
        <button
          className="support-btn"
          onClick={() => (window.location.href = "/support")}
        >
          Contact support
        </button>
      </div>
    </div>
  );
}
